/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-12T08:26:51.015
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseSalesPromotionItem,
	listRentHouseSalesPromotionItemInit,
	listRentHouseSalesPromotionItemByAuthorizations,
	deleteRentHouseSalesPromotionItem
} from '@api/rentmanage/RentHouseSalesPromotionItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseSalesPromotionItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseSalesPromotionItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseSalesPromotionItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseSalesPromotionItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseSalesPromotionItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseSalesPromotionItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseSalesPromotionItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseSalesPromotionItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
